import React from 'react';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { Box, Container } from '@mui/material';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import ChatPage from './pages/ChatPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RadarPage from './pages/RadarPage';
import ReadingPage from './pages/ReadingPage';
import RegisterPage from './pages/RegisterPage';
import WordDetailPage from './pages/WordDetailPage';
import { AuthProvider, ProtectedRoute } from './utils/AuthContext';

const theme = createTheme({
  palette: {
    primary: { main: '#1a73e8' },
    secondary: { main: '#0891b2' },
    background: { default: '#f8fafc', paper: '#ffffff' },
    text: { primary: '#111827', secondary: '#6b7280' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h2: { fontWeight: 800 },
    h4: { fontWeight: 800 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 12, fontWeight: 700 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { boxShadow: '0 16px 40px rgba(15, 23, 42, 0.06)' },
      },
    },
  },
});

function ProtectedLayout() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
      <Navbar />
      <Container maxWidth="xl" sx={{ py: { xs: 3, md: 4 } }}>
        <Outlet />
      </Container>
    </Box>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<ProtectedLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/word/:text" element={<WordDetailPage />} />
                <Route path="/reading" element={<ReadingPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/radar" element={<RadarPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
